import React from 'react'
import SliderImport, {type SliderProps} from 'rc-slider'
import 'rc-slider/assets/index.css'
import styles from './AudioSlider.module.scss'

const Slider: React.FunctionComponent<SliderProps> = SliderImport as any

export const AudioSlider = ({
    value,
    onChange,
}: {
    value: number
    onChange: (value: number) => void
}) => (
    <Slider
        className={styles.sliderWrapper}
        max={1}
        min={0}
        onChange={onChange}
        step={0.01}
        value={value}
    />
)
